import type { UserData } from '@/types/auth'
import { normalizeRolePolicies } from '@/lib/auth/normalizeRolePolicies'

/** Policy check — Angular authService.hasPolicy parity. */
export function hasPolicy(user: UserData | null, policies: string[]): boolean {
  if (!user || !policies || policies.length === 0) return false

  const currentRole = user.current_role

  // ROLE_ADMIN has all policies
  if (currentRole?.role_name === 'ROLE_ADMIN') {
    return true
  }

  const list = normalizeRolePolicies(currentRole?.policy)
  if (list.length > 0) {
    return policies.some((policy) => list.includes(policy))
  }

  return false
}

export function isUnderwriter(user: UserData | null): boolean {
  return user?.current_role?.role_name === 'ROLE_UNDERWRITER'
}

/** Liberty Sales: list access only, no detail drill-in. */
export function isLibertySalesRole(user: UserData | null): boolean {
  return user?.current_role?.role_name === 'ROLE_LIBERTY_SALES'
}

export function isLibertyFinanceManagerRole(user: UserData | null): boolean {
  return user?.current_role?.role_name === 'ROLE_LIBERTY_FIN_MGR'
}

/** Detail link clickable when `application_detail_view` and not Liberty Sales (Angular). */
export function canUserOpenApplicationDetail(user: UserData | null): boolean {
  const canViewDetail = user ? hasPolicy(user, ['application_detail_view']) : true
  return canViewDetail && !isLibertySalesRole(user)
}

